export default __webpack_public_path__ + "static/media/VNU_M625_04.e63fc45c.png";